import React, { Fragment, useMemo, useState } from 'react';
import { useAppHomeTitle } from '@/hooks/useTitle';
import { Button, Image, Radio, Toast } from 'antd-mobile';

import './index.less';
import defaultUserIcon from '@/assets/maidanglao_user_default.png';
import unionPayIcon from '@/assets/union-pay.png';
import useLogin from '@/hooks/useLogin';
import useQuery from '@/hooks/useQuery';
import { useNavigate } from 'react-router-dom';

const protocolTerms = [
  { title: '《隐私协议》', url: 'https://www.mcd.cn/page.html?file=policy', key: 'policy' },
  {
    title: '《会员协议》',
    url: 'https://www.mcd.cn/page.html?file=memberServiceAgreement',
    key: 'memberServiceAgreement',
  },
  { title: '《使用条款》', url: 'https://www.mcd.cn/page.html?file=conditions', key: 'conditions' },
] as const;

type LoginPageQuery = {
  /**
   * 登录成功之后将跳转到此地址
   */
  redirectUrl?: string;
};

/**
 * 登录页面
 * 本页面接受一个callback的query，登录成功之后将跳转至此query
 */
const UnionpayLogin = () => {
  useAppHomeTitle('云闪付登录页');

  /* 登录相关 */
  const navigate = useNavigate();
  const { redirectUrl } = useQuery<LoginPageQuery>() as LoginPageQuery;
  const onLoginSuccess = () => {
    console.log('登录成功, 重定向至:', redirectUrl);
    if (redirectUrl) {
      navigate(redirectUrl, { replace: true });
    } else {
      navigate(-1);
    }
  };
  const { navLogin, btn: loginDom } = useLogin({ onSuccess: onLoginSuccess, ignoreInit: true });

  /* 协议条款相关 */
  const [isCheckedProtocol, setIsCheckedProtocol] = useState(false);
  const protocolText = useMemo(
    () =>
      protocolTerms.map((term, index) => (
        <Fragment key={term.key}>
          <a href={term.url}>{term.title}</a>
          {index < protocolTerms.length - 1 && '、'}
        </Fragment>
      )),
    [],
  );

  return (
    <div className="login-page">
      <div className="login-container">
        <Image className="user-icon" src={defaultUserIcon} />
        <span className="welcome-line">欢迎您，麦麦</span>
        {/*<span className="welcome-tip">为了您的账户安全，请绑定手机号</span>*/}
        <Button
          onClick={() => {
            if (isCheckedProtocol) {
              navLogin();
            } else {
              Toast.show('请阅读并勾选下方协议');
            }
          }}
          className="login-btn"
          shape="rounded">
          <Image className="unionpay-icon" src={unionPayIcon} alt="云闪付" />
          <span className="login-btn-text">云闪付授权登录</span>
        </Button>
      </div>
      <div className="legal-container">
        <Radio
          checked={isCheckedProtocol}
          onChange={setIsCheckedProtocol}
          className="legal-checker"
          style={{ '--icon-size': '18px' }}>
          <span className="legal-line">我已阅读并同意{protocolText}</span>
        </Radio>
      </div>
      {loginDom}
    </div>
  );
};
export default UnionpayLogin;
